module.exports = __webpack_public_path__ + "media/puerta_automatica/dimensions-da8f4050.png";